import { Link } from 'react-router-dom';
import { categories } from '@/mocks/homeData';
import { useInView } from '@/hooks/useInView';

export default function CategorySection() {
  const { ref, isInView } = useInView();

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div
        ref={ref}
        className={`px-4 md:px-6 transition-all duration-700 ${
          isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
              <i className="ri-apps-line mr-1"></i>分类导航
            </span>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 font-heading">
              探索漫画分类
            </h2>
            <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
              按类型浏览，快速找到你喜欢的<strong>韩漫</strong>类型
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
            {categories.map((cat) => {
              const bgColor =
                cat.color === 'accent'
                  ? 'bg-accent-100 hover:bg-accent-200'
                  : cat.color === 'primary'
                  ? 'bg-primary-100 hover:bg-primary-200'
                  : 'bg-secondary-100 hover:bg-secondary-200';
              const iconColor =
                cat.color === 'accent'
                  ? 'text-accent-600'
                  : cat.color === 'primary'
                  ? 'text-primary-600'
                  : 'text-secondary-600';
              const countColor =
                cat.color === 'accent'
                  ? 'text-accent-500'
                  : cat.color === 'primary'
                  ? 'text-primary-500'
                  : 'text-secondary-500';

              return (
                <Link
                  key={cat.id}
                  to="/category/all"
                  className={`group flex items-center gap-4 p-4 md:p-5 rounded-xl ${bgColor} transition-all duration-300 cursor-pointer`}
                >
                  <div className={`w-11 h-11 rounded-lg flex items-center justify-center ${iconColor} bg-background-50`}>
                    <i className={`${cat.icon} text-xl`}></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm font-semibold text-foreground-900 font-heading whitespace-nowrap">
                      {cat.name}
                    </h3>
                    <p className={`text-xs font-medium ${countColor} mt-0.5`}>
                      {cat.count.toLocaleString()} 部
                    </p>
                  </div>
                  <i className="ri-arrow-right-s-line text-foreground-400 group-hover:translate-x-1 transition-transform"></i>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}